const Loader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
      <div className="w-24 h-24 border-[12px] border-t-blue-500 border-gray-300 border-solid rounded-full animate-spin"></div>
    </div>
  );
};

export default Loader;
